import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationContentBlockerMetaGet = {
    path: "/template/content-blocker/meta",
    method: ERouteHttpVerb.GET
};
export { routeLocationContentBlockerMetaGet };
